module.exports = __webpack_public_path__ + "static/hero-tour-70021a71fb4c9354d78ccb6890e840b5.jpg";